import React, { Component, Fragment } from 'react';
import Toggle from 'react-toggle';
import CurrencyInput from 'react-currency-input';

import { Content, ToggleContainer } from './styles';
import { Row, Label, CurrencyLabel } from '../../../../../assets/styles';

class Promotion extends Component {
  state = {
    promotion: false,
    price: 0,
    priceMasked: '',
    priceError: false,
    priceInvalid: false,
    priceFocus: false,
  }

  componentWillMount = () => {
    const { currentMaterial } = this.props;

    if (currentMaterial && currentMaterial.specialPrice) {
      this.setState({
        promotion: true,
        price: currentMaterial.specialPrice,
        priceMasked: new Intl.NumberFormat('pt-BR', { style: 'currency', currency: 'BRL' }).format(currentMaterial.specialPrice),
      });
    }
  }

  handleSubmit = async () => {
    const { promotion } = this.state;

    this.setState({
      priceError: false,
      priceInvalid: false,
    });

    if (promotion) {
      await this.validateInputs();

      const {
        price,
        priceError,
      } = this.state;

      if (!priceError) {
        return {
          promotion: true,
          error: false,
          specialPrice: price,
        };
      }

      return { promotion: true, error: true };
    }

    return { promotion: false };
  }

  validateInputs = () => {
    const { price } = this.state;
    const { originalPrice } = this.props;

    if (price === 0 || price > 999999.99) this.setState({ priceError: true });
    if (price >= originalPrice) this.setState({ priceError: true, priceInvalid: true });
  }

  handleToggleButton = () => {
    this.setState(state => ({
      promotion: !state.promotion,
      price: 0,
      priceMasked: '',
      priceError: false,
      priceInvalid: false,
    }));
  }

  handlePriceValueChange = (event, maskedValue, floatValue) => {
    this.setState({
      priceMasked: maskedValue,
      price: floatValue,
    });
  }

  onFocus = (type) => {
    this.setState({ [type]: true });
  }

  onBlur = (type) => {
    this.setState({ [type]: false });
  }

  render() {
    const {
      promotion,
      priceMasked,
      priceError,
      priceInvalid,
      priceFocus,
    } = this.state;
    const { originalPrice } = this.props;

    return (
      <Fragment>
        {this.props.active && (
          <Content>
            <ToggleContainer>
              <Toggle
                defaultChecked={promotion}
                icons={false}
                onChange={this.handleToggleButton}
              />
              <span>Ativar promoção</span>
            </ToggleContainer>
            <Row>
              <div className="row-2">
                <Label>
                  <p className="fieldName">Preço original</p>
                  <CurrencyLabel>
                    <CurrencyInput
                      readOnly
                      size="10"
                      prefix="R$ "
                      decimalSeparator=","
                      thousandSeparator="."
                      className="input"
                      value={originalPrice}
                    />
                  </CurrencyLabel>
                </Label>
                <Label />
              </div>
              <div className="row-2">
                <Label>
                  <p className="fieldName">Preço promocional</p>
                  <CurrencyLabel error={priceError} onFocusInput={priceFocus}>
                    <CurrencyInput
                      readOnly={!promotion}
                      size="10"
                      prefix="R$ "
                      decimalSeparator=","
                      thousandSeparator="."
                      className="input"
                      value={priceMasked}
                      onChangeEvent={this.handlePriceValueChange}
                      onFocus={() => promotion && this.onFocus('priceFocus')}
                      onBlur={() => this.onBlur('priceFocus')}
                    />
                  </CurrencyLabel>
                  {priceInvalid && <p className="inputMessage errorMessage">O preço promocional não pode ser maior ou igual ao preço original.</p>}
                </Label>
                <Label />
              </div>
            </Row>
          </Content>
        )}
      </Fragment>
    );
  }
}

export default Promotion;
